import { Suspense, useEffect } from 'react';
import { Text } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { SearchResultTabPanel } from './searchResultTabPanel';
import { PageCard } from 'component/DefaultCard/PageCard';
import { SubscribeButtonCluster } from 'component/nav/SubscribeButtonCluster/SubscribeButtonCluster';
export const HomeLayout = () => {
  const [t] = useTranslation(['home', 'translation'], { useSuspense: false });

  useEffect(() => {
    //until they fix this eslint bug
    // eslint-disable-next-line no-unused-expressions
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute?.('content', t('home:pageDescription'));
  }, [t]);
  return (
    <PageCard
      header={
        <>
          <h1
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              margin: '0',
            }}
          >
            {t('Security Update Guide', {
              ns: 'translation',
              defaultValue: 'Security Update Guide',
            })}
          </h1>
          <SubscribeButtonCluster />
        </>
      }
    >
      <Text block={true} style={{ paddingBottom: '1em' }}>
        {t(
          'pageDescription',
          '⚠ Translation data failed to load. If this continues to happen, please contact MSRC.',
          { ns: 'home' }
        )}
      </Text>
      <Suspense fallback={<div style={{ height: '20em' }}></div>}>
        <SearchResultTabPanel />
      </Suspense>
    </PageCard>
  );
};
